import { InjectionToken }  from '@angular/core';
import { AtI18nInterface } from './at-i18n.interface';

export const AT_I18N = new InjectionToken<AtI18nInterface>('nz-i18n');
